module.exports=function(scope){ return `{
    "data": {
        "glasses": false,
        "faceMapType": 1,
        "creationStatus": 0,
        "faceMap": FACEMAP_VALUE
        "isLowQuality": false
    },
    "meta": {
        "code": 200,
        "message": "A FaceMap was created.",
        "ok": true,
        "m": {
            "createFaceMapFromImageTimeInMS": ...,
            "totalDurationInMS": ...
        }
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/facemap-post.json.tpl